import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Table from "@empd/reactable";
import "@empd/reactable/lib/styles.css";

import {
    Container,
    Row,
    Col,
    Card,
    CardImg,
    Form,
    Button,
    Breadcrumb,
    Spinner,
    Alert,
    Modal,
    Dropdown,
} from "react-bootstrap";

import CustomNavbar from "../../components/CustomNavbar";
import CustomFooter from "../../components/CustomFooter";
import ShowInfo from "../../components/ShowInfo";

import api from "../../service/api";
import { TOKEN_USERTYPE, TOKEN_BRANCHID } from "../../service/tokens";

const BigListList = (props) => {
    const [bigLists, setBigLists] = useState([]);
    const [emptyDataElement, setEmptyDataElement] = useState(
        <Spinner animation="grow" />
    );
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState("");
    const [alertText, setAlertText] = useState("");
    const [alertVariant, setAlertVariant] = useState("");

    useEffect(
        function () {
            async function loadBigLists() {
                const userType = Number(
                    window.localStorage.getItem(TOKEN_USERTYPE)
                );
                const branchId = Number(
                    window.localStorage.getItem(TOKEN_BRANCHID)
                );

                try {
                    const responseGetBigLists = await api.get(
                        `/biglist${
                            userType !== 0 ? "-by-branch/" + branchId : ""
                        }`
                    );
                    if (responseGetBigLists.data.error) {
                        alert("Erro ao buscar os listões. Contate o suporte!");
                        setTimeout(function () {
                            props.history.push("/dashboard");
                        }, 2000);
                    } else {
                        if (responseGetBigLists.data.data.length === 0)
                            setEmptyDataElement(
                                <Alert variant="dark">
                                    Não existem registros.
                                </Alert>
                            );
                        else setBigLists(responseGetBigLists.data.data);
                    }
                } catch (error) {
                    setEmptyDataElement(
                        <Alert variant="warning">Erro ao buscar.</Alert>
                    );
                }
            }

            loadBigLists();
        },
        [props.history]
    );

    return (
        <>
            <CustomNavbar />
            <main>
                <Container>
                    <Row>
                        <Col>
                            <ShowInfo
                                title={alertTitle}
                                text={alertText}
                                show={showAlert}
                                variant={alertVariant}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Breadcrumb>
                                <Breadcrumb.Item
                                    style={{
                                        cursor: "pointer",
                                    }}
                                    onClick={() =>
                                        props.history.push("/dashboard")
                                    }
                                >
                                    Dashboard
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active>
                                    Listar Listões
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table
                                searchPlaceholder="Procurar"
                                emptyPlaceholder={emptyDataElement}
                                columns={[
                                    {
                                        name: "ID",
                                        sortable: true,
                                        selector: "id",
                                    },
                                    {
                                        name: "Nome",
                                        sortable: true,
                                        selector: "name",
                                    },
                                    {
                                        name: "Opções",
                                        cell: function (cellInfo) {
                                            return (
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        variant="success"
                                                        id="dropdown-basic"
                                                    >
                                                        Opções
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu
                                                        style={{
                                                            padding: 0,
                                                        }}
                                                    >
                                                        <Dropdown.Item
                                                            style={{
                                                                padding: 0,
                                                            }}
                                                        >
                                                            <Button
                                                                variant="primary"
                                                                style={{
                                                                    width:
                                                                        "100%",
                                                                    borderRadius: 0,
                                                                }}
                                                                onClick={() => {
                                                                    // setAdView(
                                                                    //     cellInfo
                                                                    // );
                                                                    // handleShowModalInfo();
                                                                }}
                                                            >
                                                                Editar
                                                            </Button>
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            style={{
                                                                padding: 0,
                                                            }}
                                                        >
                                                            <Button
                                                                style={{
                                                                    width:
                                                                        "100%",
                                                                    borderRadius: 0,
                                                                }}
                                                                variant="danger"
                                                                onClick={() => {
                                                                    var trash = window.confirm(
                                                                        "Para Excluir pressione OK!"
                                                                    );
                                                                    if (
                                                                        trash ===
                                                                        true
                                                                    ) {
                                                                        async function deleteAd(
                                                                            id
                                                                        ) {
                                                                            try {
                                                                                const responseDeleteAd = await api.delete(
                                                                                    `/ad/${id}`
                                                                                );
                                                                                if (
                                                                                    responseDeleteAd.status ===
                                                                                    204
                                                                                ) {
                                                                                    setShowAlert(
                                                                                        true
                                                                                    );
                                                                                    setAlertTitle(
                                                                                        "Anúncio excluído com sucesso!"
                                                                                    );
                                                                                    setAlertText(
                                                                                        `O anúncio ${cellInfo.name} foi excluída com sucesso!`
                                                                                    );
                                                                                    setAlertVariant(
                                                                                        "success"
                                                                                    );

                                                                                    const updatedList = bigLists.filter(
                                                                                        (
                                                                                            itemBigList,
                                                                                            index
                                                                                        ) =>
                                                                                            itemBigList.id !==
                                                                                            cellInfo.id
                                                                                    );
                                                                                    setBigLists(
                                                                                        updatedList
                                                                                    );
                                                                                }
                                                                            } catch (err) {
                                                                                setShowAlert(
                                                                                    true
                                                                                );
                                                                                setAlertTitle(
                                                                                    "Não foi possível excluir o anúncio!"
                                                                                );
                                                                                setAlertText(
                                                                                    `O anúncio ${cellInfo.name} não pode ser excluído. Contate o suporte!`
                                                                                );
                                                                                setAlertVariant(
                                                                                    "danger"
                                                                                );
                                                                            }
                                                                        }
                                                                        deleteAd(
                                                                            cellInfo.id
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                Excluir
                                                            </Button>
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            );
                                        },
                                    },
                                ]}
                                data={bigLists}
                            />
                        </Col>
                    </Row>
                </Container>
            </main>
            <CustomFooter />
        </>
    );
};

export default withRouter(BigListList);
